import AsyncAction, { AsyncActionWithCancel } from './async-action'
import { createReducer } from 'typesafe-actions'

export default function createOperationReducer(
  ...actions: (
    | AsyncAction<any, any, any, any, any, any>
    | AsyncActionWithCancel<any, any, any, any, any, any, any, any>
  )[]
) {
  return createReducer<string | null>(null)
    .handleAction(
      actions.map((act) => act.success),
      (state, action) => {
        return action.meta || state
      },
    )
    .handleAction(
      actions.map((act) => act.failure),
      (state, action) => {
        return action.meta || state
      },
    )
}
